import React, {useState} from "react";
import { Navbar, Image, Container, Row, Col } from "react-bootstrap";
import UserWayAccessibilityMenu from "../UserWayAccessibilityMenu";
import "./index.css";

export default function Header({ isMobile }){
const [navbar, setNavbar] = useState(false);

  const changebackground = () => {
    if(window.scrollY >= 20){
      setNavbar(true);
    }else{
      setNavbar(false);
    }
  };

  window.addEventListener('scroll', changebackground);
    return(
      <Container>
        <Navbar expand="lg"
          fixed="top"
          bg="dark"
          variant="dark"
          className={navbar ? 'navbar active' : 'navbar'}>
          <Container>
            <Row className="headerlogos">
              <Col xl={6}>
                <a href="https://www.swmc.com/" target="_blank" rel='noreferrer'>
                  <Image src ={"https://resources.swmc.com/swmc-images/Homepage/New/SunWest41YearsofTrust-Blue.png"} 
                      alt="Sun West logo" title="Sun West logo" className="sunwest-logo mt-2" />
                </a>
              </Col>
              <Col xl={5}>
                <a href="https://www.angelai.com/" rel='noreferrer' target="_blank">
                  <Image src ='https://resources.swmc.com/angel-ai/brandnameflipwithlogostatic.gif' 
                      alt="AngelAi logo" title="AngelAi-logo" className="morgan-university-logo mt-2" />
                </a>
              </Col>
            </Row>
          </Container>
          {!isMobile && (
            <UserWayAccessibilityMenu color="black" width={40} height={40}  />
          )}
        </Navbar>
      </Container>
    );
}